import { render, staticRenderFns } from "./PrizeItem.vue?vue&type=template&id=7da23cee&scoped=true&"
import script from "./PrizeItem.vue?vue&type=script&lang=js&"
export * from "./PrizeItem.vue?vue&type=script&lang=js&"
import style0 from "./PrizeItem.vue?vue&type=style&index=0&id=7da23cee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da23cee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7da23cee')) {
      api.createRecord('7da23cee', component.options)
    } else {
      api.reload('7da23cee', component.options)
    }
    module.hot.accept("./PrizeItem.vue?vue&type=template&id=7da23cee&scoped=true&", function () {
      api.rerender('7da23cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/components/PrizeItem.vue"
export default component.exports